import type { ServiceHighlightsSection } from "@/data/types";
import serviceHighlightsData from "@/data/serviceHighlights.json";

export function useServiceHighlightsData() {
  return {
    serviceHighlightsData: serviceHighlightsData as ServiceHighlightsSection,
  };
}